import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase, Loader2, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Seo from "@/components/Seo";
import { ownerApi, OWNER_TOKEN } from "@/lib/ownerApi";
import Overview from "./Overview";
import SalaryMonth from "./SalaryMonth";
import Settlement from "./Settlement";
import RulesEditor from "./RulesEditor";
import Groups from "./Groups";
import Account from "./Account";
import Reconcile from "./Reconcile";
import ProfitDashboard from "./ProfitDashboard";
import Expenses from "./Expenses";
import TeamScores from "./TeamScores";

const TABS = [["overview", "Fees Due & Earned", Overview], ["salary", "Monthly Salary", SalaryMonth],
  ["settlement", "Year-end Settlement", Settlement], ["rules", "Salary Settings", RulesEditor],
  ["groups", "Salary Groups", Groups], ["profit", "Profit & Forecast", ProfitDashboard], ["expenses", "Expenses", Expenses], ["team", "Teacher Scorecard", TeamScores], ["recon", "Excel Import & Reconciliation", Reconcile], ["account", "Account", Account]];

export default function OwnerDashboard() {
  const nav = useNavigate();
  const [me, setMe] = useState(null);
  useEffect(() => {
    if (!localStorage.getItem(OWNER_TOKEN)) { nav("/entrepreneur/login", { replace: true }); return; }
    ownerApi.get("/me").then(({ data }) => setMe(data)).catch(() => {});
  }, [nav]);
  const logout = () => { localStorage.removeItem(OWNER_TOKEN); nav("/entrepreneur/login", { replace: true }); };
  if (!me) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-emerald-800" /></div>;
  return (
    <div className="min-h-screen bg-stone-50" data-testid="owner-dashboard">
      <Seo title="Entrepreneur" />
      <header className="bg-emerald-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-xl bg-emerald-700 flex items-center justify-center"><Briefcase className="h-5 w-5" /></div>
            <div><div className="font-heading font-extrabold">PTG Entrepreneur</div><div className="text-xs text-emerald-200">{me.email}</div></div>
          </div>
          <Button variant="ghost" className="text-emerald-100 hover:bg-emerald-900 hover:text-white" onClick={logout} data-testid="owner-logout"><LogOut className="h-4 w-4 mr-1" /> Logout</Button>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <Tabs defaultValue="overview">
          <TabsList className="flex flex-wrap h-auto gap-1 bg-white border border-stone-200 p-1 justify-start">
            {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`owner-tab-${v}`} className="data-[state=active]:bg-emerald-800 data-[state=active]:text-white">{l}</TabsTrigger>)}
          </TabsList>
          {TABS.map(([v, , C]) => <TabsContent key={v} value={v} className="mt-5"><C /></TabsContent>)}
        </Tabs>
      </main>
    </div>
  );
}
